import React, { useState } from "react";

// Read-Only Component
export const InsuranceDataReadOnly = ({ data }) => {
  if (!data) return null;

  const renderField = (label, value) => {
    if (value === null || value === undefined || value === "") return null;
    return (
      <div className="mb-2">
        <span className="text-sm font-medium text-gray-600">{label}: </span>
        <span className="text-sm text-gray-900">{value}</span>
      </div>
    );
  };

  const renderAddress = (address) => {
    if (!address) return null;
    const fullAddress = [
      address.street,
      address.city,
      address.state,
      address.zip,
      address.country,
    ]
      .filter(Boolean)
      .join(", ");
    return fullAddress || null;
  };

  const renderViolations = (violations) => {
    if (!violations) return null;
console.log(violations)
    // If it's an array of violation objects
    if (Array.isArray(violations)) {
      return violations.map((violation, index) => (
        <div key={index} className="text-xs bg-red-50 p-2 rounded mb-1">
          <div className="font-medium">{violation.description}</div>
          {violation.date && (
            <div className="text-gray-500">{violation.date}</div>
          )}
        </div>
      ));
    }

    // If it's a single violation object
    if (typeof violations === "object" && violations.description) {
      return (
        <div className="text-xs bg-red-50 p-2 rounded">
          <div className="font-medium">{violations.description}</div>
          {violations.date && (
            <div className="text-gray-500">{violations.date}</div>
          )}
        </div>
      );
    }

    // If it's just a string
    if (typeof violations === "string") {
      return violations;
    }

    return null;
  };

  return (
    <div className="space-y-6">
      {/* Policy Information */}
      <div className="bg-white rounded-lg p-4 border">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">
          Policy Information
        </h3>
        {renderField("Policy Number", data.policy?.carrier_policy_number)}
        {renderField("Status", data.policy?.status)}
        {renderField("Effective Date", data.policy?.effective_date)}
        {renderField("Expiration Date", data.policy?.expiration_date)}
        {renderField("Term (Months)", data.policy?.term_months)}
      </div>
      {/* Insurance Carrier */}
      <div className="bg-white rounded-lg p-4 border">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">
          Insurance Carrier
        </h3>
        <div className="flex justify-between items-start mb-2">
          <h4 className="font-medium text-gray-700">{data.carrier?.name}</h4>
          <span className="text-sm text-gray-600">
            {data.carrier?.contact?.phone}
          </span>
        </div>
        {data.carrier?.address && (
          <div className="text-sm text-gray-600">
            {renderAddress(data.carrier?.address)}
          </div>
        )}
      </div>
      {/* MGA */}
      <div className="bg-white rounded-lg p-4 border">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">
          MGA
        </h3>
        <div className="flex justify-between items-start mb-2">
          <h4 className="font-medium text-gray-700">{data.mga?.name}</h4>
          <span className="text-sm text-gray-600">
            {data.mga?.contact?.phone}
          </span>
        </div>
        {data.carrier?.address && (
          <div className="text-sm text-gray-600">
            {renderAddress(data.mga?.address)}
          </div>
        )}
      </div>
      {/* Agent Information */}
      <div className="bg-white rounded-lg p-4 border">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">
          Agent Information
        </h3>
        <div className="flex justify-between items-start mb-2">
          <h4 className="font-medium text-gray-700">{data.agent?.name}</h4>
          <span className="text-sm text-gray-600">
            {data.agent?.contact?.phone}
          </span>
        </div>
        {renderField("Agent ID", data.agent?.id)}
        <div className="grid grid-cols-2 gap-x-4 text-sm">
          {data.agent?.address && (
            <div>
              <span className="text-sm text-gray-900">
                {renderAddress(data.agent.address)}
              </span>
            </div>
          )}
        </div>
      </div>
      {/* Named Insureds */}
      {data.named_insureds && data.named_insureds.length > 0 && (
        <div className="bg-white rounded-lg p-4 border">
          <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">
            Named Insureds
          </h3>
          {data.named_insureds.map((insured, index) => (
            <div
              key={index}
              className="mb-4 last:mb-0 p-3 bg-gray-50 rounded-md"
            >
              {renderField("Full Name", insured.full_name)}
              {renderField("Address", renderAddress(insured.address))}
            </div>
          ))}
        </div>
      )}
      {/* Covered Vehicles */}
      {data.covered_vehicles && Object.keys(data.covered_vehicles).length > 0 && (
        <div className="bg-white rounded-lg p-4 border">
          <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">
            Covered Vehicles
          </h3>
          {Object.entries(data.covered_vehicles).map(
            ([vin, vehicle], index) => (
              <div
                key={vin}
                className="mb-4 last:mb-0 p-3 bg-gray-50 rounded-md"
              >
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-gray-700">
                    {vehicle.year} {vehicle.make} {vehicle.model}
                  </h4>
                  <span className="text-xs text-gray-500">VIN: {vin}</span>
                </div>

                <div className="grid grid-cols-3 gap-x-4 gap-y-1 text-sm mb-3">
                  {renderField("Territory", vehicle.territory)}
                  {renderField("State", vehicle.state)}
                  {renderField("Use", vehicle.use)}
                </div>

                {vehicle.garaging_address && (
                  <div className="mb-3">
                    {renderField(
                      "Garaging Address",
                      renderAddress(vehicle.garaging_address)
                    )}
                  </div>
                )}

                {vehicle.drivers && vehicle.drivers.length > 0 && (
                  <div>
                    <span className="text-sm font-medium text-gray-600">
                      Drivers:{" "}
                    </span>
                    <span className="text-sm text-gray-900">
                      {vehicle.drivers
                        .map(
                          (d) => `${d.full_name} (${d.relationship_to_insured})`
                        )
                        .join(", ")}
                    </span>
                  </div>
                )}
              </div>
            )
          )}
        </div>
      )}
      {/* Coverage by Vehicle */}
      {data.coverages_by_vehicle &&
        Object.keys(data.coverages_by_vehicle).length > 0 && (
          <div className="bg-white rounded-lg p-4 border">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">
              Coverage by Vehicle
            </h3>
            {Object.entries(data.coverages_by_vehicle).map(
              ([vin, coverages], index) => {
                const vehicle = data.covered_vehicles?.[vin];
                const vehicleInfo = vehicle
                  ? `${vehicle.year} ${vehicle.make} ${vehicle.model}`
                  : vin;

                return (
                  <div
                    key={vin}
                    className="mb-6 last:mb-0 p-3 bg-gray-50 rounded-md"
                  >
                    <h4 className="font-medium text-gray-700 mb-3">
                      {vehicleInfo} (VIN: {vin})
                    </h4>
                    {coverages.map((coverage, coverageIndex) => (
                      <div
                        key={coverageIndex}
                        className="mb-3 last:mb-0 p-2 bg-white rounded border-l-4 border-blue-200"
                      >
                        <div className="flex justify-between items-start mb-2">
                          <h5 className="font-medium text-gray-800">
                            {coverage.friendly_name}
                          </h5>
                          {coverage.is_declined ? (
                            <span className="text-sm bg-red-100 text-red-700 px-2 py-1 rounded">
                              Declined
                            </span>
                          ) : (
                            <span className="text-sm bg-green-100 text-green-700 px-2 py-1 rounded">
                              Active
                            </span>
                          )}
                        </div>
                        {!coverage.is_declined && (
                          <div className="text-sm text-gray-600 space-y-1">
                            {coverage.per_person_limit_cents &&
                              renderField(
                                "Per Person Limit",
                                `$${(
                                  coverage.per_person_limit_cents / 100
                                ).toLocaleString()}`
                              )}
                            {coverage.per_incident_limit_cents &&
                              renderField(
                                "Per Incident Limit",
                                `$${(
                                  coverage.per_incident_limit_cents / 100
                                ).toLocaleString()}`
                              )}
                            {coverage.premium_cents &&
                              renderField(
                                "Premium",
                                `$${(coverage.premium_cents / 100).toFixed(2)}`
                              )}
                            {coverage.deductible_cents &&
                              renderField(
                                "Deductible",
                                `$${(
                                  coverage.deductible_cents / 100
                                ).toLocaleString()}`
                              )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                );
              }
            )}
          </div>
        )}
      {/* Drivers */}
      {data.drivers && data.drivers.length > 0 && (
        <div className="bg-white rounded-lg p-4 border">
          <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">
            Drivers
          </h3>
          {data.drivers.map((driver, index) => (
            <div
              key={index}
              className="mb-4 last:mb-0 p-3 bg-gray-50 rounded-md"
            >
              <div className="flex justify-between items-start mb-2">
                <h4 className="font-medium text-gray-700">
                  {driver.first_name} {driver.last_name}
                </h4>
                <span className="text-xs text-gray-500">
                  Points: {driver.points}
                </span>
              </div>

              <div className="grid grid-cols-3 gap-x-4 gap-y-1 text-sm mb-2">
                {renderField("License #", driver.license_number)}
                {renderField("License State", driver.license_state)}
                {renderField("DOB", driver.dob)}
              </div>

              <div className="grid grid-cols-3 gap-x-4 gap-y-1 text-sm">
                {renderField("Gender", driver.gender)}
                {renderField("Marital Status", driver.marital_status)}
                {renderField("Occupation", driver.occupation)}
              </div>

              {driver.violations && (
                <div className="mt-2">
                  {renderViolations(driver.violations || [])}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
